// extracted by mini-css-extract-plugin
export default {"content":"Vehicles_content__4X1Nq","vehicles":"Vehicles_vehicles__yVuHm"};